module.exports = __webpack_public_path__ + "static/media/Gate.42ce474d.png";